module.exports = __webpack_public_path__ + "static/media/maxime.f87536aa.jpg";